// import { useEffect, useRef, useState } from "react";
// import React from "react";
// import TextField from "@mui/material/TextField";
// import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import "./StudentAddress.css";
// import { styled, Typography } from "@mui/material";

// let lat;
// let lng;
// let current = "";
// let flag = 2;
// let map, marker, infowindow;

// const SectionHeader = styled(Typography)(({ theme }) => ({
//   fontWeight: 600,
//   color: theme.palette.primary.main,
//   marginBottom: theme.spacing(3),
//   position: "relative",
//   "&:after": {
//     content: '""',
//     position: "absolute",
//     bottom: -8,
//     left: 0,
//     width: "50px",
//     height: "3px",
//     backgroundColor: theme.palette.primary.main,
//     borderRadius: "3px",
//   },
// }));

// const Address = (props) => {
//   const pickupAddressRef = useRef();
//   const dropAddressRef = useRef();
//   const [pickupStopDetails, setPickupStopDetails] = useState();
//   const [dropStopDetails, setDropStopDetails] = useState();
//   const [isCustomStopSelected, setIsCustomStopSelected] = useState(false);
//   const [isCustomStopSelectedD, setIsCustomStopSelectedD] = useState(false);
//   const [pickupError, setPickupError] = useState(false);
//   const [dropError, setDropError] = useState(false);

//   useEffect(() => {
//     const isValid =
//       !pickupError && !dropError && pickupStopDetails && dropStopDetails;
//     props.onValidationChange(isValid);
//   }, [pickupError, dropError, pickupStopDetails, dropStopDetails]);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src =
//       "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=initMap&libraries=places&v=weekly";
//     script.async = true;
//     script.onload = () => {
//       initMap();
//     };

//     document.body.appendChild(script);
//   }, [isCustomStopSelected, isCustomStopSelectedD]);

//   useEffect(() => {
//     if (props.edit) {
//       pickupAddressRef.current.value = props.riderData?.PickupPoint || "";
//       dropAddressRef.current.value = props.riderData?.DropPoint || "";
//     }
//   }, [props.edit, props.riderData]);

//   const validateAddress = (address, type) => {
//     if (!address || address.trim() === "") {
//       if (type === "pickup") {
//         setPickupError("Pickup address is required");
//       } else {
//         setDropError("Drop address is required");
//       }
//       return false;
//     }

//     if (type === "pickup") {
//       setPickupError("");
//     } else {
//       setDropError("");
//     }
//     return true;
//   };

//   const dropLat = +props?.riderData?.DropLL?.split(",")[0];
//   const dropLng = +props?.riderData?.DropLL?.split(",")[1];

//   function initMap() {
//     map = new window.google.maps.Map(document.getElementById("studentmap"), {
//       center:
//         !isNaN(dropLat) && !isNaN(dropLng)
//           ? {
//               lat: +props?.riderData?.DropLL?.split(",")[0],
//               lng: +props?.riderData?.DropLL?.split(",")[1],
//             }
//           : { lat: 23.0225, lng: 72.5714 },
//       zoom: props.edit ? 15 : 11,
//       disableDefaultUI: true,
//       fullscreenControl: true,
//       zoomControl: true,
//     });

//     var input1 = document.getElementById("pac-input1");
//     var input2 = document.getElementById("pac-input2");

//     var autocomplete = [];
//     autocomplete[0] = new window.google.maps.places.Autocomplete(input1);
//     autocomplete[1] = new window.google.maps.places.Autocomplete(input2);
//     var geocoder = new window.google.maps.Geocoder();

//     autocomplete[0].bindTo("bounds", map);
//     autocomplete[1].bindTo("bounds", map);
//     infowindow = new window.google.maps.InfoWindow();
//     var infowindowContent = document.getElementById("infowindow-content");
//     infowindow.setContent(infowindowContent);
//     marker = new window.google.maps.Marker({
//       position: props.edit
//         ? {
//             lat: +props?.riderData?.DropLL?.split(",")[0],
//             lng: +props?.riderData?.DropLL?.split(",")[1],
//           }
//         : "",
//       map: map,
//       draggable: true,
//       animation: window.google.maps.Animation.DROP,
//       anchorPoint: new window.google.maps.Point(0, -29),
//     });

//     window.google.maps.event.addListener(marker, "dragend", function (marker) {
//       geocoder.geocode(
//         {
//           latLng: marker.latLng,
//         },
//         function (value) {
//           const fullAddress = value?.[0]?.formatted_address;
//           infowindowContent.children["place-address"].textContent = fullAddress;
//           infowindowContent.children["place-name"].textContent = "";

//           if (current === "pickup") {
//             pickupAddressRef.current.value = fullAddress;
//           } else {
//             dropAddressRef.current.value = fullAddress;
//           }

//           // Pass the full formatted address to parent
//           props.addressEntered(current, fullAddress, lat, lng);
//         }
//       );
//       lat = marker.latLng.lat();
//       lng = marker.latLng.lng();
//     });

//     autocomplete.forEach((autocompleteInstance, index) => {
//       autocompleteInstance.addListener("place_changed", () => {
//         infowindow.close();
//         marker.setVisible(false);
//         const place = autocompleteInstance.getPlace();

//         if (!place.geometry || !place.geometry.location) {
//           window.alert("No details available for input: '" + place.name + "'");
//           return;
//         }

//         map.setCenter(place.geometry.location);
//         map.setZoom(place.geometry.viewport ? 18 : 13);
//         marker.setPosition(place.geometry.location);
//         marker.setVisible(true);

//         lat = marker.getPosition().lat();
//         lng = marker.getPosition().lng();

//         const fullAddress = place.formatted_address;
//         current = index === 0 ? "pickup" : "drop";

//         // Update the input field with full address
//         if (current === "pickup") {
//           pickupAddressRef.current.value = fullAddress;
//         } else {
//           dropAddressRef.current.value = fullAddress;
//         }

//         // Pass the full formatted address to parent immediately
//         props.addressEntered(current, fullAddress, lat, lng);
//       });
//     });
//   }

//   window.initMap = initMap;

//   const addressChangeHandler = (address) => {
//     // This is now handled directly in the place_changed event listener
//   };

//   const stopChnageHandler = (stopName, type) => {
//     if (stopName.toLowerCase() === "custom") {
//       marker.setDraggable(true);
//       marker.setVisible(false);
//       map.setCenter({ lat: 23.0225, lng: 72.5714 });
//       map.setZoom(11);
//       infowindow.close();
//       if (type === "pickup") {
//         setIsCustomStopSelected(true);
//         setPickupError("Please enter a custom pickup address");
//       } else {
//         setIsCustomStopSelectedD(true);
//         setDropError("Please enter a custom drop address");
//       }
//     } else {
//       let desiredStop = props.stops.filter(
//         (val) => val.StopName === stopName
//       )[0];
//       lat = +desiredStop?.StopLatlong?.split(",")[0];
//       lng = +desiredStop?.StopLatlong?.split(",")[1];
//       map.setCenter({ lat: lat, lng: lng });
//       marker.setVisible(true);
//       marker.setPosition({ lat: lat, lng: lng });
//       marker.setDraggable(false);
//       map.setZoom(18);
//       infowindow.open(map, marker);
//       infowindow.setContent(stopName);
//       props.addressEntered(type, stopName, lat, lng);
//       // setIsCustomStopSelected(false);
//       // setIsCustomStopSelectedD(false);
//       if (type === "pickup") {
//         setIsCustomStopSelected(false);
//         setPickupError("");
//       } else {
//         setIsCustomStopSelectedD(false);
//         setDropError("");
//       }
//     }
//     if (type === "pickup") setPickupStopDetails(stopName);
//     else setDropStopDetails(stopName);
//   };

//   const stopChnageHandler1 = (stopName, type) => {
//     if (stopName.toLowerCase() === "custom") {
//       marker.setDraggable(true);
//       marker.setVisible(false);
//       map.setCenter({ lat: 23.0225, lng: 72.5714 });
//       map.setZoom(11);
//       infowindow.close();
//       if (type === "pickup") {
//         setIsCustomStopSelected(true);
//         setPickupError("Please enter a custom pickup address");
//       } else {
//         setIsCustomStopSelectedD(true);
//         setDropError("Please enter a custom drop address");
//       }

//       // setIsCustomStopSelectedD(true);
//     } else {
//       let desiredStop = props.stops.filter(
//         (val) => val.StopName === stopName
//       )[0];
//       lat = +desiredStop?.StopLatlong?.split(",")[0];
//       lng = +desiredStop?.StopLatlong?.split(",")[1];
//       map.setCenter({ lat: lat, lng: lng });
//       marker.setVisible(true);
//       marker.setPosition({ lat: lat, lng: lng });
//       marker.setDraggable(false);
//       map.setZoom(18);
//       infowindow.open(map, marker);
//       infowindow.setContent(stopName);
//       props.addressEntered(type, stopName, lat, lng);

//       // setIsCustomStopSelectedD(false);
//       if (type === "pickup") {
//         setIsCustomStopSelected(false);
//         setPickupError("");
//       } else {
//         setIsCustomStopSelectedD(false);
//         setDropError("");
//       }
//     }
//     if (type === "pickup") setPickupStopDetails(stopName);
//     else setDropStopDetails(stopName);
//   };

//   // ... (rest of the component remains the same)

//   return (
//     <div style={{ height: "100%", margin: "0px 10px" }}>
//       <SectionHeader variant="h6">
//         {props.type === "Student"
//           ? "Bus Stop Details"
//           : "Bus/ Cab Stop Details"}
//       </SectionHeader>

//       <div
//         id="pac-container"
//         style={{ display: "flex", flexDirection: "column", gap: "30px" }}
//       >
//         {/* Pickup Row */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-end",
//             gap: "10px",
//             justifyContent: "space-between",
//           }}
//         >
//           {props.stops.length <= 1 ||
//           pickupStopDetails?.toLowerCase() === "custom" ? (
//             <TextField
//               id="pac-input1"
//               label="From"
//               variant="standard"
//               inputRef={pickupAddressRef}
//               sx={{ width: "65%" }}
//               error={!!pickupError}
//               onChange={(e) => {
//                 current = "pickup";
//                 validateAddress(e.target.value, "pickup");
//                 // We don't call addressChangeHandler here anymore
//                 // The address will be handled by the autocomplete place_changed event
//               }}
//             />
//           ) : (
//             <FormControl
//               variant="standard"
//               sx={{ width: "65%" }}
//               error={!!pickupError}
//             >
//               <InputLabel id="pickup-select-label">From</InputLabel>
//               <Select
//                 labelId="pickup-select-label"
//                 id="pickup-select"
//                 value={pickupStopDetails || ""}
//                 onChange={(e) => stopChnageHandler(e.target.value, "pickup")}
//                 label="From"
//               >
//                 {props.stops?.map((val) => (
//                   <MenuItem
//                     key={val?.StopName}
//                     sx={{
//                       display: "block",
//                       width: "400px",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                     }}
//                     value={val?.StopName}
//                   >
//                     {val?.StopName}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {pickupError && (
//                 <Typography color="error" variant="caption">
//                   {pickupError}
//                 </Typography>
//               )}
//             </FormControl>
//           )}

//           <ArrowRightAltIcon sx={{ alignSelf: "flex-end" }} />

//           <TextField
//             id="pickup-to"
//             label="To"
//             value={props.corpName}
//             variant="standard"
//             disabled
//             sx={{ width: "25%" }}
//           />
//         </div>

//         {/* Drop Row */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-end",
//             gap: "10px",
//             justifyContent: "space-between",
//           }}
//         >
//           <TextField
//             id="drop-from"
//             label="From"
//             value={props.corpName}
//             variant="standard"
//             disabled
//             sx={{ width: "25%" }}
//           />

//           <ArrowRightAltIcon sx={{ alignSelf: "flex-end" }} />

//           {props.stops.length <= 1 ||
//           dropStopDetails?.toLowerCase() === "custom" ? (
//             <TextField
//               id="pac-input2"
//               label="To"
//               variant="standard"
//               inputRef={dropAddressRef}
//               sx={{ width: "65%" }}
//               error={!!dropError}
//               onChange={(e) => {
//                 current = "drop";
//                 validateAddress(e.target.value, "drop");
//               }}
//             />
//           ) : (
//             <FormControl
//               variant="standard"
//               sx={{ width: "65%" }}
//               error={!!dropError}
//             >
//               <InputLabel id="drop-select-label">To</InputLabel>
//               <Select
//                 labelId="drop-select-label"
//                 id="drop-select"
//                 value={dropStopDetails || ""}
//                 onChange={(e) => stopChnageHandler1(e.target.value, "drop")}
//                 label="To"
//               >
//                 {props.stops?.map((val) => (
//                   <MenuItem
//                     key={val.StopName}
//                     sx={{
//                       display: "block",
//                       width: "400px",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                     }}
//                     value={val.StopName}
//                   >
//                     {val.StopName}
//                   </MenuItem>
//                 ))}
//               </Select>
//               {dropError && (
//                 <Typography color="error" variant="caption">
//                   {dropError}
//                 </Typography>
//               )}
//             </FormControl>
//           )}
//         </div>
//       </div>

//       {/* Map Section */}
//       <div
//         id="jay"
//         style={{ marginTop: "30px", height: "300px", border: "1px solid #ccc" }}
//       >
//         <div id="studentmap" style={{ width: "100%", height: "100%" }}></div>
//       </div>

//       {/* Info Window */}
//       <div
//         id="infowindow-content"
//         style={{ display: "none", paddingTop: "10px" }}
//       >
//         <span id="place-name" style={{ fontWeight: "bold" }}></span>
//         <br />
//         <span id="place-address"></span>
//       </div>
//     </div>
//   );
// };

// export default React.memo(Address);

import { useEffect, useRef, useState } from "react";
import React from "react";
import TextField from "@mui/material/TextField";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./StudentAddress.css";
import { Box, Grid, styled, Typography } from "@mui/material";

let lat;
let lng;
let current = "";
let map, marker, infowindow;

const SectionHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(3),
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    bottom: -8,
    left: 0,
    width: "50px",
    height: "3px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "3px",
  },
}));

const Address = (props) => {
  const pickupAddressRef = useRef();
  const dropAddressRef = useRef();
  // const [pickupStopDetails, setPickupStopDetails] = useState("");
  const [pickupStopDetails, setPickupStopDetails] = useState(
    props.edit ? props.riderData?.PickupPoint || "" : ""
  );
  // const [dropStopDetails, setDropStopDetails] = useState("");
  const [dropStopDetails, setDropStopDetails] = useState(
    props.edit ? props.riderData?.DropPoint || "" : ""
  );
  const [isCustomStopSelected, setIsCustomStopSelected] = useState(false);
  const [isCustomStopSelectedD, setIsCustomStopSelectedD] = useState(false);
  const [pickupError, setPickupError] = useState("");
  const [dropError, setDropError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    if (props.edit && props.riderData) {
      // Set initial values from riderData in edit mode
      setPickupStopDetails(props.riderData.PickupPoint || "");
      setDropStopDetails(props.riderData.DropPoint || "");

      if (props.riderData.PickupLL) {
        const [lat, lng] = props.riderData.PickupLL.split(",").map(Number);
        props.setPickupLatLng({ lat, lng });
      }

      if (props.riderData.DropLL) {
        const [lat, lng] = props.riderData.DropLL.split(",").map(Number);
        props.setDropLatLng({ lat, lng });
      }
    }
  }, [props.edit, props.riderData]);

  useEffect(() => {
    if (mapLoaded && window.google && window.google.maps) {
      // Wait for DOM elements to be available
      const checkAndInit = () => {
        const mapElement = document.getElementById("studentmap");
        const input1 = document.getElementById("pac-input1");
        const input2 = document.getElementById("pac-input2");
        
        if (mapElement && input1 && input2) {
          initMap();
        } else {
          // Retry after a short delay if elements aren't ready
          setTimeout(checkAndInit, 100);
        }
      };
      checkAndInit();
    }
  }, [mapLoaded, props.edit, props.riderData]);

  // Validate addresses and notify parent
  useEffect(() => {
    const isValid =
      !pickupError && !dropError && pickupStopDetails && dropStopDetails;
    props.onValidationChange(isValid);

    if (pickupStopDetails && dropStopDetails) {
      setAddressError("");
    }
  }, [pickupError, dropError, pickupStopDetails, dropStopDetails]);

  useEffect(() => {
    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      setMapLoaded(true);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]'
    );
    if (existingScript) {
      existingScript.addEventListener("load", () => {
        setMapLoaded(true);
      });
      return;
    }

    // Create and load the script
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&libraries=places&v=weekly";
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      if (window.google && window.google.maps) {
        setMapLoaded(true);
      }
    };

    script.onerror = () => {
      console.error("Failed to load Google Maps API");
    };

    document.head.appendChild(script);

    return () => {
      // Only remove script if it was added by this component
      // Don't remove if it might be used elsewhere
      const scriptToRemove = document.querySelector(
        'script[src*="maps.googleapis.com/maps/api/js"]'
      );
      if (scriptToRemove && scriptToRemove === script) {
        // Don't remove - might be used by other components
        // document.head.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (props.edit && props.riderData) {
      // Use setTimeout to ensure DOM elements are rendered
      const timer = setTimeout(() => {
        if (pickupAddressRef.current) {
          pickupAddressRef.current.value = props.riderData?.PickupPoint || "";
        }
        if (dropAddressRef.current) {
          dropAddressRef.current.value = props.riderData?.DropPoint || "";
        }
        setPickupStopDetails(props.riderData?.PickupPoint || "");
        setDropStopDetails(props.riderData?.DropPoint || "");
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [props.edit, props.riderData]);

  const validateAddress = (address, type) => {
    if (!address || address.trim() === "") {
      const errorMsg = `${
        type === "pickup" ? "Pickup" : "Drop"
      } address is required`;
      if (type === "pickup") {
        setPickupError(errorMsg);
      } else {
        setDropError(errorMsg);
      }
      setAddressError("Please select valid pickup and drop addresses");
      return false;
    }

    if (type === "pickup") {
      setPickupError("");
    } else {
      setDropError("");
    }

    if (pickupStopDetails && dropStopDetails) {
      setAddressError("");
    }

    return true;
  };

  const dropLat = +props?.riderData?.DropLL?.split(",")[0];
  const dropLng = +props?.riderData?.DropLL?.split(",")[1];

  function initMap() {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps API not loaded yet");
      return;
    }

    const mapElement = document.getElementById("studentmap");
    const input1 = document.getElementById("pac-input1");
    const input2 = document.getElementById("pac-input2");

    if (!mapElement || !input1 || !input2) {
      console.error("Required DOM elements not found");
      return;
    }

    // Check if map is already initialized to avoid re-initialization
    if (map) {
      return;
    }

    const centerLat = !isNaN(dropLat) && !isNaN(dropLng)
      ? +props?.riderData?.DropLL?.split(",")[0]
      : 23.0225;
    const centerLng = !isNaN(dropLat) && !isNaN(dropLng)
      ? +props?.riderData?.DropLL?.split(",")[1]
      : 72.5714;

    map = new window.google.maps.Map(mapElement, {
      center: { lat: centerLat, lng: centerLng },
      zoom: props.edit ? 15 : 11,
      disableDefaultUI: true,
      fullscreenControl: true,
      zoomControl: true,
    });

    var autocomplete = [];
    
    // Only create autocomplete if inputs exist
    if (input1) {
      autocomplete[0] = new window.google.maps.places.Autocomplete(input1);
    }
    if (input2) {
      autocomplete[1] = new window.google.maps.places.Autocomplete(input2);
    }
    
    var geocoder = new window.google.maps.Geocoder();

    if (autocomplete[0]) {
      autocomplete[0].bindTo("bounds", map);
    }
    if (autocomplete[1]) {
      autocomplete[1].bindTo("bounds", map);
    }
    
    infowindow = new window.google.maps.InfoWindow();
    var infowindowContent = document.getElementById("infowindow-content");
    if (infowindowContent) {
      infowindow.setContent(infowindowContent);
    }
    
    const markerPosition = props.edit && props?.riderData?.DropLL
      ? {
          lat: +props.riderData.DropLL.split(",")[0],
          lng: +props.riderData.DropLL.split(",")[1],
        }
      : { lat: centerLat, lng: centerLng };

    marker = new window.google.maps.Marker({
      position: markerPosition,
      map: map,
      draggable: true,
      animation: window.google.maps.Animation.DROP,
      anchorPoint: new window.google.maps.Point(0, -29),
    });

    window.google.maps.event.addListener(marker, "dragend", function (event) {
      const position = event.latLng;
      geocoder.geocode(
        {
          location: position,
        },
        function (results, status) {
          if (status === "OK" && results && results[0]) {
            const fullAddress = results[0].formatted_address;
            if (infowindowContent) {
              const placeAddress = infowindowContent.querySelector("#place-address");
              const placeName = infowindowContent.querySelector("#place-name");
              if (placeAddress) placeAddress.textContent = fullAddress;
              if (placeName) placeName.textContent = "";
            }

            lat = position.lat();
            lng = position.lng();

            if (current === "pickup") {
              if (pickupAddressRef.current) {
                pickupAddressRef.current.value = fullAddress;
              }
              setPickupStopDetails(fullAddress);
              validateAddress(fullAddress, "pickup");
            } else {
              if (dropAddressRef.current) {
                dropAddressRef.current.value = fullAddress;
              }
              setDropStopDetails(fullAddress);
              validateAddress(fullAddress, "drop");
            }

            props.addressEntered(current, fullAddress, lat, lng);
          }
        }
      );
    });

    autocomplete.forEach((autocompleteInstance, index) => {
      if (!autocompleteInstance) return;
      
      autocompleteInstance.addListener("place_changed", () => {
        if (infowindow) infowindow.close();
        if (marker) marker.setVisible(false);
        const place = autocompleteInstance.getPlace();

        if (!place.geometry || !place.geometry.location) {
          window.alert("No details available for input: '" + (place.name || "") + "'");
          return;
        }

        const location = place.geometry.location;
        map.setCenter(location);
        map.setZoom(place.geometry.viewport ? 18 : 13);
        
        if (marker) {
          marker.setPosition(location);
          marker.setVisible(true);
        }

        lat = location.lat();
        lng = location.lng();

        const fullAddress = place.formatted_address || "";
        current = index === 0 ? "pickup" : "drop";

        if (current === "pickup") {
          if (pickupAddressRef.current) {
            pickupAddressRef.current.value = fullAddress;
          }
          setPickupStopDetails(fullAddress);
          validateAddress(fullAddress, "pickup");
        } else {
          if (dropAddressRef.current) {
            dropAddressRef.current.value = fullAddress;
          }
          setDropStopDetails(fullAddress);
          validateAddress(fullAddress, "drop");
        }

        props.addressEntered(current, fullAddress, lat, lng);
      });
    });
  }

  const stopChangeHandler = (stopName, type) => {
    if (!map || !marker || !infowindow) {
      console.error("Map not initialized yet");
      return;
    }

    if (stopName.toLowerCase() === "custom") {
      marker.setDraggable(true);
      marker.setVisible(false);
      map.setCenter({ lat: 23.0225, lng: 72.5714 });
      map.setZoom(11);
      infowindow.close();

      if (type === "pickup") {
        setIsCustomStopSelected(true);
        setPickupError("Please enter a custom pickup address");
      } else {
        setIsCustomStopSelectedD(true);
        setDropError("Please enter a custom drop address");
      }

      setAddressError("Please select valid pickup and drop addresses");
    } else {
      let desiredStop = props.stops.find((val) => val.StopName === stopName);
      if (desiredStop) {
        lat = +desiredStop?.StopLatlong?.split(",")[0];
        lng = +desiredStop?.StopLatlong?.split(",")[1];
        map.setCenter({ lat: lat, lng: lng });
        marker.setVisible(true);
        marker.setPosition({ lat: lat, lng: lng });
        marker.setDraggable(false);
        map.setZoom(18);
        infowindow.open(map, marker);
        infowindow.setContent(stopName);

        if (type === "pickup") {
          setIsCustomStopSelected(false);
          setPickupError("");
        } else {
          setIsCustomStopSelectedD(false);
          setDropError("");
        }

        props.addressEntered(type, stopName, lat, lng);
      }
    }

    if (type === "pickup") {
      setPickupStopDetails(stopName);
    } else {
      setDropStopDetails(stopName);
    }
  };

  return (
    <div style={{ height: "100%", margin: "0px 10px" }}>
      {/* <SectionHeader>Address Details</SectionHeader> */}
      {/* <TextField
        fullWidth
        label="Address"
        name="address"
        variant="standard"
        value={props.formData.address}
        onChange={props.handleInputChange}
        size="small"
        error={!!props.errorHandler.addressError}
        helperText={props.errorHandler.addressError}
        sx={{ mb: 2 }}
      /> */}

      {/* <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Pincode"
            name="pincode"
            variant="standard"
            value={props.formData.pincode}
            onChange={props.pincodeChangeHandler}
            size="small"
            inputProps={{ maxLength: 6 }}
            error={!!props.errorHandler.pincodeError}
            helperText={props.errorHandler.pincodeError}
            sx={{ mb: 1 }}
          />
          <Box
            sx={{
              maxHeight: "150px",
              overflowY: "auto",
              border:
                props.isNearByAddresses?.length > 0
                  ? "1px solid #e0e0e0"
                  : "none",
              borderRadius: "4px",
              p: props.isNearByAddresses?.length > 0 ? 1 : 0,
            }}
          >
            {props.isNearByAddresses?.map((address, index) => (
              <Typography
                key={index}
                id={index + 11}
                onClick={props.nearbyAddressClickHandler}
                sx={{
                  cursor: "pointer",
                  p: 1,
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#f0f7ff",
                    color: "primary.main",
                  },
                  fontSize: "0.875rem",
                }}
              >
                {address?.Name}
              </Typography>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Area"
            name="area"
            variant="standard"
            value={props.formData.area}
            onChange={props.handleInputChange}
            size="small"
            error={!!props.errorHandler.areaError}
            helperText={props.errorHandler.areaError}
            sx={{ mb: 1 }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="City"
            name="city"
            variant="standard"
            value={props.formData.city}
            onChange={props.handleInputChange}
            size="small"
            error={!!props.errorHandler.cityError}
            helperText={props.errorHandler.cityError}
            sx={{ mb: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="State"
            name="state"
            variant="standard"
            value={props.formData.state}
            onChange={props.handleInputChange}
            size="small"
            error={!!props.errorHandler.stateError}
            helperText={props.errorHandler.stateError}
            sx={{ mb: 1 }}
          />
        </Grid>
      </Grid> */}

      <SectionHeader>
        {props.type === "Student" ? "Stop Details" : "Stop Details"}
      </SectionHeader>

      {addressError && (
        <Typography
          color="error"
          variant="caption"
          sx={{ display: "block", mb: 2 }}
        >
          {addressError}
        </Typography>
      )}

      <div
        id="pac-container"
        style={{ display: "flex", flexDirection: "column", gap: "30px" }}
      >
        {/* Pickup Row */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          {props.stops.length <= 1 ||
          pickupStopDetails?.toLowerCase() === "custom" ? (
            <TextField
              id="pac-input1"
              label="From"
              variant="standard"
              inputRef={pickupAddressRef}
              sx={{ width: "65%" }}
              error={!!pickupError}
              helperText={props.errorMessage}
              FormHelperTextProps={{
                sx: {
                  color: "error.main", // Explicitly set to error color
                },
              }}
              onChange={(e) => {
                current = "pickup";
                setPickupStopDetails(e.target.value);
                validateAddress(e.target.value, "pickup");
              }}
            />
          ) : (
            <FormControl
              variant="standard"
              sx={{ width: "65%" }}
              error={!!pickupError}
            >
              <InputLabel id="pickup-select-label">From</InputLabel>
              <Select
                labelId="pickup-select-label"
                id="pickup-select"
                value={pickupStopDetails || ""}
                onChange={(e) => stopChangeHandler(e.target.value, "pickup")}
                label="From"
              >
                {props.stops?.map((val) => (
                  <MenuItem
                    key={val?.StopName}
                    sx={{
                      display: "block",
                      width: "400px",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                    value={val?.StopName}
                  >
                    {val?.StopName}
                  </MenuItem>
                ))}
              </Select>
              {pickupError && (
                <Typography color="error" variant="caption">
                  {pickupError}
                </Typography>
              )}
            </FormControl>
          )}

          <ArrowRightAltIcon sx={{ alignSelf: "flex-end" }} />

          <TextField
            id="pickup-to"
            label="To"
            value={props.corpName}
            variant="standard"
            disabled
            sx={{ width: "25%" }}
          />
        </div>

        {/* Drop Row */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          <TextField
            id="drop-from"
            label="From"
            value={props.corpName}
            variant="standard"
            disabled
            sx={{ width: "25%" }}
          />

          <ArrowRightAltIcon sx={{ alignSelf: "flex-end" }} />

          {props.stops.length <= 1 ||
          dropStopDetails?.toLowerCase() === "custom" ? (
            <TextField
              id="pac-input2"
              label="To"
              variant="standard"
              inputRef={dropAddressRef}
              sx={{ width: "65%" }}
              error={!!dropError}
              helperText={props.errorMessage}
              FormHelperTextProps={{
                sx: {
                  color: "error.main", // Explicitly set to error color
                },
              }}
              onChange={(e) => {
                current = "drop";
                setDropStopDetails(e.target.value);
                validateAddress(e.target.value, "drop");
              }}
            />
          ) : (
            <FormControl
              variant="standard"
              sx={{ width: "65%" }}
              error={!!dropError}
            >
              <InputLabel id="drop-select-label">To</InputLabel>
              <Select
                labelId="drop-select-label"
                id="drop-select"
                value={dropStopDetails || ""}
                onChange={(e) => stopChangeHandler(e.target.value, "drop")}
                label="To"
              >
                {props.stops?.map((val) => (
                  <MenuItem
                    key={val.StopName}
                    sx={{
                      display: "block",
                      width: "400px",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                    value={val.StopName}
                  >
                    {val.StopName}
                  </MenuItem>
                ))}
              </Select>
              {dropError && (
                <Typography color="error" variant="caption">
                  {dropError}
                </Typography>
              )}
            </FormControl>
          )}
        </div>
      </div>

      {/* Map Section */}
      <div
        id="jay"
        style={{ marginTop: "20px", height: "200px", border: "1px solid #ccc" }}
      >
        <div id="studentmap" style={{ width: "100%", height: "100%" }}></div>
      </div>

      {/* Info Window */}
      <div
        id="infowindow-content"
        style={{ display: "none", paddingTop: "5px" }}
      >
        <div id="place-name" style={{ fontWeight: "bold" }}></div>
        <div id="place-address"></div>
      </div>
    </div>
  );
};

export default React.memo(Address);
